import React from "react";
import { DndProvider, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableItem from "./DraggableItem";
import "./TaskBoard.scss";
import Iconify from "../../layouts/components/iconify/iconify";

const TaskBoard = ({ data = [], columns = [], groupByField, renderItem, onItemMove }) => {

  const moveTaskToColumn = (task, newGroup) => {
    if (onItemMove) {
      onItemMove(task, newGroup);
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="board-container">
        <div className="columns">
          {columns.map((column) => (
            <Column
              key={column.value}
              title={column.label}
              tasks={data.filter(
                (task) => task[groupByField] === column.label
              )}
              renderItem={renderItem}
              onDrop={(task) => moveTaskToColumn(task, column.value)}
            />
          ))}
        </div>
      </div>
    </DndProvider>
  );
};

const Column = ({ title, tasks, onDrop, renderItem }) => {
  const [{ isOver }, dropRef] = useDrop({
    accept: "TASK",
    drop: (item) => onDrop(item),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const formattedTitle = title.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="">
    <div
      className={`column-container ${isOver ? "is-over" : ""}`}
      ref={dropRef}
    >
      <div className="column-number">{tasks.length}</div>
      <h3 className={`column-title title-${formattedTitle}`}>{title}</h3>
      <div className="column-body">
        {tasks.length === 0 ? (
          <div className="empty-column-placeholder">Drop tasks here <Iconify icon="hugeicons:drag-03" /></div>
        ) : (
          tasks.map((task) => (
            <DraggableItem key={task.taskId ?? task.id} item={task}>
              {renderItem(task)}
            </DraggableItem>
          ))
        )}
      </div>
    </div>
          
    </div>
  );
};

export default TaskBoard;
